__turbopack_context__.v({
  "action": "e-Eszq_action",
  "clip": "e-Eszq_clip",
  "content": "e-Eszq_content",
  "count": "e-Eszq_count",
  "heading": "e-Eszq_heading",
  "reveal": "e-Eszq_reveal",
  "row": "e-Eszq_row",
});
